@if (subsidiaries.length) {
    <ul class="labelled-list mt-4 mb-4" data-testid="SubsidiariesList">
        @for (subsidiary of subsidiaries; track subsidiary.subsidiaryId) {
            <li data-cy="SubsidiariesListItem" [attr.data-testid]="'SubsidiariesListItem-' + subsidiary.subsidiaryId">
                <div class="subsidiary-logo">
                    @if (subsidiary.logoUrl) {
                        <img [src]="subsidiary.logoUrl" />
                    }
                </div>
                <strong class="label">
                    {{subsidiary.tenantName}}
                    @if (!subsidiary.isCgvAccepted) {
                        @if ((currentUserIsSupport$ | async) || subsidiary.accessLevel !== accessLevel.Admin) {
                            <small><br>{{ 'Subsidiaries.UnsignedSalesConditions' | translate }}</small>
                        }
                        @else {
                            <small>
                                <br>
                                {{ 'Subsidiaries.PleaseSignSalesConditions' | translate }}
                                <a data-cy="ToSubsidiaryDetail"
                                    [routerLink]="getSubsidiaryDetailPath(subsidiary.subsidiaryId)"
                                    translate="Subsidiaries.PleaseSignSalesConditionsLink">
                                </a>
                            </small>
                        }
                    }
                </strong>
                <div class="actions-subsidiaries d-flex">
                    @if (currentUserIsSupport$ | async) {
                        <input class="invisible" bsDatepicker
                            type="text"
                            [bsValue]="subsidiary.accessEndDate"
                            [minDate]="minDate"
                            [bsConfig]="bsConfig"
                            (onHidden)="input.value && (!subsidiary.accessEndDate || (input.value.toString() !== subsidiary.accessEndDate.toString())) && this.timeoutTenant(subsidiary.subsidiaryId, input.value)"
                            #input #dp="bsDatepicker"/>
                        @if (subsidiary.daysToTimeout < 1000000) {
                            <button (click)="timeoutTenant(subsidiary.subsidiaryId, null)"
                                class="btn mr-2 btn-success"
                                data-cy="Reactivate"
                                [ngbTooltip]="'Subsidiaries.Reactivate' | translate">
                                <i class="far fa-calendar-check"></i>
                            </button>
                        }
                        <button (click)="dp.show()"
                            data-cy="Disable"
                            class="btn mr-2 btn-{{ subsidiary.timeoutStatus }}"
                            [ngbTooltip]="(!subsidiary.accessEndDate ? 'Subsidiaries.Disable' : 'Subsidiaries.DaysToTimeout') | translate:{days:subsidiary.daysToTimeout}">
                            <i class="far fa-hourglass"></i>
                        </button>
                    }
                    @if (subsidiary.accessLevel === accessLevel.Admin) {
                        <a class="btn btn-secondary d-none d-sm-block"
                            data-cy="Edit"
                            [ngbTooltip]="'Actions.Edit' | translate"
                            [routerLink]="getSubsidiaryDetailPath(subsidiary.subsidiaryId)">
                            <i class="far fa-pencil"></i>
                        </a>
                    }
                    @if (subsidiary.tenantId) {
                        <div class="d-block d-sm-none">
                            <button (click)="redirectToTenant(subsidiary.subsidiaryId)"
                                [disabled]="(!subsidiary.isCgvAccepted) || (subsidiary.daysToTimeout <= 1)"
                                class="btn btn-primary"
                                data-cy="AccessSubsidiary">
                                <i class="fas fa-arrow-right"></i>
                            </button>
                        </div>
                        <div class="btn-group d-none d-sm-block" ngbDropdown placement="bottom-right">
                            <button (click)="redirectToTenant(subsidiary.subsidiaryId)"
                                [disabled]="(!subsidiary.isCgvAccepted) || (subsidiary.daysToTimeout <= 1)"
                                class="btn btn-primary"
                                data-cy="AccessSubsidiary">
                                {{ 'Actions.Access' | translate }}
                            </button>
                            <button id="button-split"
                                [disabled]="(!subsidiary.isCgvAccepted) || (subsidiary.daysToTimeout <= 1)"
                                type="button"
                                ngbDropdownToggle data-cy="DropdownToggle"
                                class="btn btn-primary dropdown-toggle dropdown-toggle-split">
                            </button>
                            <div ngbDropdownMenu class="dropdown-menu">
                                <button ngbDropdownItem
                                    [disabled]="(!subsidiary.isCgvAccepted) || (subsidiary.daysToTimeout <= 1)"
                                    (click)="redirectToTenantNewTab(subsidiary.subsidiaryId)"
                                    class="dropdown-item" translate="Actions.AccessNewTab" data-cy="AccessNewTab">
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </li>
        }
    </ul>
}
